import React from 'react';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { useTranslation } from 'react-i18next';
import CenteredQButton from '../Shared/CenteredQButton';
import Enter2FACode from '../Shared/Enter2FACode';

const TwoFACheck = (): JSX.Element => {
  const { t } = useTranslation(TranslationNamespaces.twoFA);

  return (
    <>
      <Enter2FACode internalRedirectTo='/Enable2FA/RecoveryCodes' />

      <CenteredQButton variant='text' to='/Enable2FA/LinkAuthenticator' fullWidth>
        {t('linkAuthenticatorAgain')}
      </CenteredQButton>
    </>
  );
};

export default TwoFACheck;
